import CultureShow from 'core/culture-show';
import fontStyles from 'styles/Fonts.module.scss';
import Image from 'core/image';
import phoneIcon from 'static/img/icons/phone-icon.svg';
import styles from 'styles/Header.module.scss';
import { useScroll } from 'hooks';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { WhiteButton } from 'core/buttons/buttons';

const KeypadNewLanding = () => {
    const t = useTranslations('header.keypad');
    const [display, setDisplay] = useState('');

    useScroll((scroll) => {
        setDisplay(scroll > 100 ? 'none' : '');
    }, []);

    return (
        <>
            <div className={styles.sHeaderNavbarRowCol}>
            </div>
            <div className={styles.sHeaderNavbarRowCol}>
                <div className={styles.keypad}>
                    <div
                        style={{
                            marginLeft: '2%',
                            marginRight: '2%',
                            display
                        }}
                    >
                        <WhiteButton
                            label={t('help-button.text')}
                            href={t('help-button.link')}
                            compact
                            whiteBorder
                        />
                    </div>
                    <CultureShow cultures={['es-ar', 'es-mx', 'pt-br']}>
                        <a
                            className={styles.phone_container}
                            href={t('phone.link')}
                            style={{ display }}
                        >
                            <Image
                                src={phoneIcon}
                                width={25}
                                height={20}
                                alt={t('phone.text')}
                            />
                            <span className={fontStyles.text_header4}>
                                {' '}{t('phone.text')}
                            </span>
                            <p className={fontStyles.text_small}>
                                {t('phone.description')}
                            </p>
                        </a>
                    </CultureShow>
                </div>
            </div>
        </>
    );
};

export default KeypadNewLanding;
